<template>
  <v-form
    ref="form"
    :lazy-validation="true"
    @submit.prevent="onSave">

    <h2>Change your password</h2>

    <div class="input-grid">
      <label class="editing">Current password</label>
      <v-text-field
        v-model="user.currentPassword"
        single-line
        solo
        :type="showCurrentPassword ? 'text' : 'password'"
        :rules="validatePassword"
        @click:append="showCurrentPassword = !showCurrentPassword">

        <template v-slot:append>
          <button
            type="button" aria-label="append icon" tabindex="-1"
            class="v-icon mdi"
            :class="{ 'mdi-eye': showCurrentPassword, 'mdi-eye-off': !showCurrentPassword }"
            @click="showCurrentPassword = !showCurrentPassword"
          ></button>
        </template>
      </v-text-field>

      <label class="editing">New password</label>
      <v-text-field
        v-model="user.newPassword"
        single-line
        solo
        :type="showNewPassword ? 'text' : 'password'"
        :rules="validatePassword"
        @click:append="showNewPassword = !showNewPassword">

        <template v-slot:append>
          <button
            type="button" aria-label="append icon" tabindex="-1"
            class="v-icon mdi"
            :class="{ 'mdi-eye': showNewPassword, 'mdi-eye-off': !showNewPassword }"
            @click="showNewPassword = !showNewPassword"
          ></button>
        </template>
      </v-text-field>

      <label class="editing">Confirm new password</label>
      <v-text-field
        v-model="user.confirmNewPassword"
        single-line
        solo
        :type="showConfirmNewPassword ? 'text' : 'password'"
        :rules="confirmNewPasswordRules"
        @click:append="showConfirmNewPassword = !showConfirmNewPassword">

        <template v-slot:append>
          <button
            type="button" aria-label="append icon" tabindex="-1"
            class="v-icon mdi"
            :class="{ 'mdi-eye': showConfirmNewPassword, 'mdi-eye-off': !showConfirmNewPassword }"
            @click="showConfirmNewPassword = !showConfirmNewPassword"
          ></button>
        </template>
      </v-text-field>
    </div>

    <div class="button-group">
      <button
        class="default-btn blue"
        :disabled="saving"
        @click="onChangePassword"
      >Update</button>
    </div>
  </v-form>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { formMixin } from '@/mixins'

export default {
  name: 'UserPasswordForm',
  mixins: [formMixin],
  data: () => ({
    user: {},
    saving: false,
    showCurrentPassword: false,
    showNewPassword: false,
    showConfirmNewPassword: false,
  }),
  computed: {
    ...mapGetters('feathers', ['apiUsers']),
    ...mapState('authStore', {
      userData: 'userData',
    }),

    confirmNewPasswordRules () {
      return [
        ...this.validatePassword,
        v => v === this.user.newPassword || 'Passwords do not match',
      ]
    },
  },
  methods: {
    async onChangePassword () {
      if (!this.$refs.form.validate()) return
      this.saving = true

      try {
        await this.apiUsers.patch(this.userData.id, {
          currentPassword: this.user.currentPassword,
          password: this.user.newPassword,
        })

        this.$refs.form.reset()
        this.addAlert({ message: 'Password successfully updated!' })
      } catch (error) {
        this.addAlert({
          type: 'error',
          message: `There was an error when updating your password: ${error.message}`,
        })
      }

      this.saving = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
